import './style.scss';

import { type BlockConfiguration, registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import { Edit } from './edit';
import { Icon } from './icon';
import { Save } from './save';
import { type InlineContainerAttributes } from './types';

const settings: BlockConfiguration< InlineContainerAttributes > = {
	...( metadata as BlockConfiguration< InlineContainerAttributes > ),
	icon: Icon,
	edit: Edit,
	save: Save,
};

registerBlockType< InlineContainerAttributes >( metadata.name, settings );
